export interface IShortcutListItem {
  label: string;
  firstKey: string;
  secondKey?: string;
  thirdKey?: string;
}

export const getTicketingActionsShortcutsList = (isMac: boolean, isViewer: boolean): IShortcutListItem[] => [
  {
    label: "Previous ticket",
    firstKey: isMac ? "⌃" : "ctrl",
    secondKey: isMac ? "⌥" : "alt",
    thirdKey: "j",
  },
  {
    label: "Next ticket",
    firstKey: isMac ? "⌃" : "ctrl",
    secondKey: isMac ? "⌥" : "alt",
    thirdKey: "k",
  },
  ...(isViewer
    ? []
    : [
        {
          label: "Tag ticket",
          firstKey: isMac ? "⌃" : "ctrl",
          secondKey: isMac ? "⌥" : "alt",
          thirdKey: "t",
        },
        {
          label: "Assign agent",
          firstKey: isMac ? "⌃" : "ctrl",
          secondKey: isMac ? "⌥" : "alt",
          thirdKey: "a",
        },
        {
          label: "Solve ticket",
          firstKey: isMac ? "⌃" : "ctrl",
          secondKey: isMac ? "⌥" : "alt",
          thirdKey: "s",
        },
        {
          label: "Close ticket",
          firstKey: isMac ? "⌃" : "ctrl",
          secondKey: isMac ? "⌥" : "alt",
          thirdKey: "c",
        },
      ]),
  {
    label: "Follow ticket",
    firstKey: isMac ? "⌃" : "ctrl",
    secondKey: isMac ? "⌥" : "alt",
    thirdKey: "f",
  },
  ...(isViewer
    ? []
    : [
        {
          label: "Reply",
          firstKey: isMac ? "⌃" : "ctrl",
          secondKey: isMac ? "⌥" : "alt",
          thirdKey: "r",
        },
        {
          label: "Write a private note",
          firstKey: isMac ? "⌃" : "ctrl",
          secondKey: isMac ? "⌥" : "alt",
          thirdKey: "n",
        },
        {
          label: "Submit message",
          firstKey: isMac ? "⌘" : "ctrl",
          secondKey: "enter",
        },
      ]),
];

export const getGlobalShortcutsList = (): IShortcutListItem[] => [
  {
    label: "Show keyboard shortcuts list",
    firstKey: "shift",
    secondKey: "/",
  },
];
